import { render, staticRenderFns } from "./MediaManage.vue?vue&type=template&id=31a5fdd7&scoped=true"
import script from "./MediaManage.vue?vue&type=script&lang=js"
export * from "./MediaManage.vue?vue&type=script&lang=js"
import style0 from "./MediaManage.vue?vue&type=style&index=0&id=31a5fdd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5fdd7",
  null
  
)

export default component.exports